export const costs = [
  'You build every chemistry lesson from scratch, hunting for diagrams of atoms, bonds and reactions scattered across the internet',
  'Students mix up atoms and ions, can\'t balance equations and freeze when they hear the word "mole"',
  "You don't have clear visuals, worked examples and safe practical guidance ready to use in class",
  'You lack the time to plan a complete, coherent chemistry course — from the atom to organic chemistry and lab skills',
];
